import React from 'react';
import { FaCalendarAlt, FaEye } from 'react-icons/fa';

const News = () => {
  const newsItems = [
    { title: "Admission Open for 2024-25 Session", date: "March 15, 2024", category: "Admission", description: "Applications are invited for various undergraduate and postgraduate programs. Last date: June 30, 2025. Apply online at www.rdsgroupofcolleges.com." },
    { title: "Annual Sports Meet 2024", date: "February 20, 2024", category: "Event", description: "The annual sports meet will be held from March 10-15, 2024. All students are encouraged to participate. Registration forms available at sports office." },
    { title: "Scholarship Announcement", date: "January 10, 2024", category: "Scholarship", description: "Merit-based scholarships available for top performers in the previous academic year. Apply before April 30, 2024. Terms and conditions apply." },
    { title: "Guest Lecture on Career Opportunities", date: "December 5, 2023", category: "Event", description: "Renowned industry experts from leading companies will guide students on career prospects in various fields. Date: December 15, 2023. Venue: Auditorium." },
    { title: "Results Declared", date: "November 20, 2023", category: "Result", description: "Semester examination results for all courses are now available on the college portal. Students can check their results using enrollment number." },
    { title: "National Seminar on Digital India", date: "October 10, 2023", category: "Seminar", description: "A two-day national seminar on 'Digital India: Challenges and Opportunities' will be organized on November 5-6, 2023. Research papers invited." },
    { title: "Placement Drive 2023-24", date: "September 5, 2023", category: "Placement", description: "Major companies like TCS, Wipro, Infosys, and HDFC Bank will visit campus for placements. Pre-placement talks scheduled from October 2023." }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-blue-50/30">
      <div className="bg-gradient-to-r from-blue-700 to-indigo-700 py-20 text-center text-white">
        <h1 className="text-4xl md:text-5xl font-bold mb-4">Latest News</h1>
        <div className="w-20 h-1 bg-yellow-400 mx-auto rounded-full mb-4"></div>
        <p className="text-lg max-w-2xl mx-auto">Stay updated with the latest happenings at our college</p>
      </div>

      <div className="container mx-auto px-6 py-16">
        <div className="max-w-4xl mx-auto space-y-6">
          {newsItems.map((item, idx) => (
            <div key={idx} className="bg-white rounded-2xl p-6 shadow-md hover:shadow-lg transition-all hover:-translate-y-1">
              <div className="flex flex-wrap items-center justify-between mb-3">
                <div className="flex items-center gap-2">
                  <FaCalendarAlt className="text-blue-600 text-sm" />
                  <span className="text-sm text-gray-500">{item.date}</span>
                </div>
                {/* Fixed: Category badge now has white text on blue background */}
                <span className="px-3 py-1 bg-blue-600 text-white rounded-full text-xs font-semibold">{item.category}</span>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-2">{item.title}</h3>
              <p className="text-gray-600 mb-4">{item.description}</p>
              <button className="text-blue-600 font-semibold text-sm flex items-center gap-1 hover:gap-2 transition-all">
                Read More <FaEye className="text-xs" />
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default News;